const cancel = 'Cancelar'
const save = 'Salvar'

export default {

  global: {
    generalError: 'Puxa vida! Não conseguimos processar a solicitação. Por favor, recarregue a página.',
    signature: 'Atenciosamente,',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
    },

    addButton: {
      add: 'Add',
    },

    attachments: {
      add: 'Adicionar CV ou outros anexos',
      placeholderWithDescription: 'Adicione os anexos solicitados',
      remove: 'Remover',
      allowedFileTypes: 'Tipos de arquivos permitidos',
      errors: {
        size: 'O arquivo é muito grande, o tamanho máximo para os arquivos é de 5MB.',
        empty: 'O arquivo não tem dados',
        invalidType: fileType => `Desculpe, mas os arquivos ${fileType} não são permitidos por motivos de segurança`,
        typeNotWhitelisted: 'Desculpe, este tipo de arquivo não é permitido.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Política de Privacidade',
      termsLinkText: 'Termos e condições',
      privacyPolicyText: 'Valorizamos sua privacidade, leia nossa ',
      termsText1: 'Leie e aceite o ',
      termsText2: 'antes de fornecer seus dados pessoais',
      privacyLink: 'https://new.recright.com/privacy-policy',
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Se não quiser que processemos seus dados pessoais, você pode pedir a remoção deles enviando uma mensagem para ${mail}.`,
      customSupportPrivacyInfo: link => `Se você não deseja que processemos seus dados pessoais, solicite a remoção por este meio: ${link}.`,
    },

    buttons: {
      close: 'Fechar',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get default competencies',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: 'Remover tomada',
      confirm: 'Tentar de novo',
    },

    confirmButton: {
      wait: count => `Aguarde ${count}`,
      confirm: 'Confirmar',
    },

    controlStatus: {
      text: {
        empty: 'Preencher',
        valid: () => 'Pronto',
      },
      textarea: {
        empty: 'Preencher',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Definir',
        valid: () => 'Pronto',
      },
      file: {
        empty: 'Selecionar',
        valid: () => 'Alterar',
      },
      list: {
        empty: 'Adicionar',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Procurar',
        valid: () => 'Pronto',
      },
    },

    cookieConsentModal: {
      title: 'Nosso site usa cookies',
      body: 'Ao aceitar todos os cookies, você concorda com o armazenamento de cookies em seu dispositivo para aprimorar a navegação no site, analisar o uso e auxiliar em nossos esforços de marketing.',
      learnMoreLinkText: 'Saiba mais sobre como usamos cookies',
      learnMoreLink: 'https://new.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Gerenciar Cookies',
      acceptAll: 'Aceitar todos os cookies',
      manageTitle: 'Gerenciar preferências de consentimento',
      necessaryCookiesTitle: 'Cookies necessários',
      necessaryCookiesBody:
        'Esses cookies são necessários para o funcionamento do site e não podem ser desativados em nossos sistemas.',
      performanceCookiesTitle: 'Cookies de desempenho',
      performanceCookiesBody:
        'Esses cookies permitem contar visitas e fontes de tráfego para que possamos medir e melhorar o desempenho do nosso site.',
      confirmChoices: 'Confirmar minhas escolhas',
      marketingCookiesTitle: 'Cookies de marketing',
      marketingCookiesBody:
        'Estes cookies permitem-nos personalizar a publicidade e avaliar o seu desempenho.',
      functionalCookiesTitle: 'Cookies de funcionalidade',
      functionalCookiesBody:
        'Estes cookies são usados para melhorar a funcionalidade do site. Sem eles, certas funcionalidades podem ficar indisponíveis. Exemplos de cookies de funcionalidade incluem serviços de bate-papo na web e preferências do usuário.',
    },

    emailAddresses: {
      remove: 'Remover',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Proibido',
      content: 'Nosso servidor educadamente (mas firmemente) se recusou a atender um pedido feito por seu navegador. Observe que o Recright deve ser usado com um único dispositivo/navegador (ao mesmo tempo).',
      link: 'Página inicial',
    },

    error404: {
      heading: 'Não há nada por lá',
      content: 'Nós olhamos com atenção, mas não há nenhuma página no endereço que você colocou. Talvez você tenha seguido um link expirado ou digitado o endereço errado por acidente.',
      link: 'Página inicial',
    },

    error410: {
      heading: 'Fechado',
      content: 'O trabalho não pode ser mostrado porque ele está fechado ou o período de candidatura foi encerrado.',
      link: 'Página inicial',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Inicializando…',
      connection_error_hint: 'Não foi possível estabelecer uma conexão de rede.\nTente recarregar a página.',
      permission_hint: 'Você precisa permitir que este site use sua webcam e microfone.',
      searching_camera_hint: 'Procurando uma webcam...',
      camera_reserved_hint: 'Outra aplicativo ou página reservou sua webcam.\nPor favor, feche esse aplicativo e recarregue a página.',
      camera_reserved_hint_chrome_extra: '\n\nCaro usuário Chrome, você precisa permitir que o Recright use a webcam a partir do diálogo abaixo da barra de endereços.',
      no_camera_hint: 'A webcam não foi encontrada.',
      no_mic_hint: 'O microfone não foi encontrado.',
      uploading_text: 'Enviando...',
      rtmpt_in_use: 'Este passo não seria necessário, se o administrador da sua rede\npermitisse RTMP. Pergunte-nos como.',
      preview_text: 'A webcam está no modo de pré-visualização',
      close_text: 'Feche a câmera',
      remove_text: 'Remover tomada',
      noflash_errortext_install: link => `Parece que você não tem o Adobe Flash Player. Você precisa de um plugin Flash para gravar vídeos. Obtenha o Flash aqui: ${link}`,
      noflash_errortext_enable: link => `Se você já instalou o flash, mas você ainda vê esta mensagem. Veja aqui: ${link}`,
      noflash_errortext_differentbrowser: 'Como alternativa, você pode tentar usar um navegador compatível com a gravação em HTML5. Sugerimos o Chrome ou o Firefox.',
    },

    footer: {
      terms: 'Termos',
      license: 'General Terms of Service',
      privacyPolicy: 'Política de privacidade',
      customSupport: link => `Entre em contato: ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Como você classificaria sua experiência com a entrevista?',
      howWouldYouRateJobAd: 'Como você avaliaria a sua experiência com o aplicativo?',
      yourResponseIsAnonymous: 'Sua resposta é anônima.',
      thankYouFeedback: 'Obrigado por seus comentários!',
    },

    candidateFooter: {
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Desculpe, este tipo de arquivo não é permitido.',
      isRequired: 'Este campo é obrigatório.',
      isEmail: value => `${value} não é um e-mail válido.`,
      isDate: value => `${value} não é uma data válida.`,
      invalidUrl: 'URL inválida.',
      singleHireEndError: 'Uma contratação única não pode ser usada por mais de 60 dias.',
      isNotTooOldForLive: 'A data está no passado.',
      isNotAfterEndDate: 'The date is after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added.',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: 'Nome',
      city: 'Cidade natal',
      email: 'E-mail',
      phone: 'Número de telefone',
      applyForPosition: 'Candidatar-se à vaga',
      back: 'Voltar',
      continue: 'Continuar',
      submit: 'Enviar',
      saveForLater: 'Continuar mais tarde',
      namePlaceholder: 'Insira seu nome',
      emailPlaceholder: 'Insira seu endereço de e-mail',
      phonePlaceholder: 'Insira seu número de telefone',
      cityPlaceholder: 'Insira a cidade em que reside atualmente',
      links: 'Adicione links, como o do seu perfil do LinkedIn',
      legendBasicInfo: 'Informações básicas',
      legendLinks: 'Links',
      legendAttachments: 'Anexos',
      legendAdditionalFields: 'Informações adicionais',
      coverLetter: 'Carta de apresentação',
      attachments: 'Anexos',
      introduction: 'Escreva uma breve apresentação aqui',
      thankYou: 'Obrigado.',
      luck: 'Boa sorte!',
      close: 'Fechar',
      required: 'Os itens marcados com um asterisco * são obrigatórios.',
    },

    jobAdContainer: {
      endTime: date => (date ? `aberta até ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Candidatar-se à vaga',
    },

    jobAdQuickInterview: {
      back: 'Voltar',
      submit: 'Enviar',
      saveForLater: 'Continuar mais tarde',
      title: 'Entrevista rápida em vídeo',
      description: 'Para conhecermos você mais rápido, gostaríamos que você respondesse à nossa entrevista rápida. Mostre sua personalidade e dê alma à sua inscrição.',
      requiredNote: 'Observe que esta é uma parte do processo de candidatura, e o recrutador receberá sua candidatura só depois de você gravar sua resposta.',
      reminderNote: 'Você pode gravar a resposta imediatamente, ou continuar mais tarde, e então receberá um lembrete por e-mail.',
    },

    jobAdRow: {
      responses: 'Candidaturas',
      status: {
        open: 'Aberta',
        filled: 'Preenchida',
        cancelled: 'Cancelada',
        done: 'Concluído',
        close: 'Fechar',
        draft: 'Fechada (rascunho)',
        hidden: 'Ocultas',
      },
    },

    interviewRow: {
      responses: 'Candidatos',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Mostrar perfil do LinkedIn',
    },

    linkedInButton: {
      error: 'Erro ao buscar o perfil. Por favor, tente novamente.',
      buttonText: 'Inscreva-se com o LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Você pode usar seu perfil do LinkedIn para preencher o formulário de candidatura',
      linkedInOr: 'Ou',
      error: 'Erro ao buscar o perfil. Por favor, tente novamente.',
    },

    linkListInput: {
      addField: 'Adicionar',
      removeField: 'Remover',
      invalidUrl: 'URL inválida.',
    },

    loadingButton: {
      loading: 'Carregando…',
      saving: 'Salvando...',
      sending: 'Enviando...',
    },

    modalApplicationForm: {
      applyForPosition: 'Inscrever-se para a vaga',
      continue: 'Continuar',
      name: 'Insira seu nome',
      email: 'Insira seu endereço de e-mail',
      phoneNumber: 'Insira seu número de telefone',
      links: 'Você pode inserir links',
      legendLinks: 'Links',
      legendAttachments: 'Anexos',
      coverLetter: 'Carta de apresentação',
      attachments: 'Anexos',
      introduction: 'Escreva a sua apresentação aqui',
      thankYou: 'Obrigado.',
      luck: 'Boa sorte!',
      close: 'Fechar',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Fechar',
    },

    modalLinkShare: {
      title: 'Link público compartilhável',
      info: 'Aqui está o endereço público de um anúncio de emprego que você pode compartilhar.\nQualquer pessoa interessada na vaga pode ver o anúncio e, em seguida, decidir se candidatar.\nVocê receberá a notificação usual quando as candidaturas começarem a chegar.\n\nAqui está um link público para o anúncio da vaga:',
    },

    modalVideoAdd: {
      title: 'Adicionar um novo vídeo',
      chooseTitle: 'Adicionar um novo vídeo',
      titlePlaceholder: 'Digite o título do vídeo aqui',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Carregar um novo vídeo',
      info: 'O tamanho máximo permitido do vídeo é 500 MB. Recomendamos que os vídeos sejam compactados antes do envio, assim o envio e a conversão levarão menos tempo.',
    },

    modalCandidateInfo: [
      {
        headline: 'Grave a sua resposta em vídeo ',
        content: 'quantas vezes quiser. Os vídeos serão salvos imediatamente após a gravação e você pode voltar para a entrevista em vídeo pelo link que você recebeu por e-mail.',
        mobileContent: 'quantas vezes quiser. Adicione o vídeo à entrevista. Você verá o vídeo que está sendo enviado e salvo na entrevista. Você pode voltar para a entrevista em vídeo pelo link que recebeu em seu e-mail.<br><br><strong>Se a sua tela permanecer preta e você estiver usando um dispositivo móvel da Apple, você encontrará instruções sobre como resolver o problema <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">aqui</a>.</strong>',
      },
      {
        headline: 'Após a gravação, ',
        content: 'certifique-se de que o vídeo seja reproduzido corretamente e sua voz possa ser ouvida. Quando você pressionar o botão Enviar, sua resposta será bloqueada e você não poderá mais editá-lo.',
      },
      {
        headline: 'Quando terminar a entrevista, ',
        content: 'pressione o botão "Enviar respostas e concluir a entrevista". Depois disso, você não poderá mais voltar para a entrevista em vídeo. Se você deseja fechar esta página, mas continuar mais tarde com a entrevista, pressione o botão "Continuar mais tarde".',
      },
      {
        headline: 'Se precisar de ajuda ',
        content: mailto => `para responder à entrevista em vídeo, clique no botão "Ajuda" no canto inferior direito da página ou envie um e-mail para ${mailto}.`,
        customContent: link => `Entre em contato: ${link}`,
      },
    ],

    navigationBar: {
      back: 'Voltar',
      dashboard: 'Painel',
      frontpage: 'Página inicial',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `Telefone no formato ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      yourRatingReset: 'Reset your vote',
      averageRating: 'Classificação média',
      reset: 'redefinir',
    },

    share: {
      share: 'Compartilhar no',
      copy: 'Copiar link',
    },

    sort: {
      sort: 'Classificar',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Selecionado',
      change: 'Alterar',
    },

    video: {
      videoNotFound: 'O vídeo está sendo processado ou não foi encontrado',
      retry: 'Tentar novamente',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Enviar ou gravar um novo vídeo' : 'Selecionar arquivo'),
      videoPlaceholder: 'Grave a sua resposta',
      uploadPlaceholderCandidate: 'Enviar um vídeo',
      submit: 'Enviar resposta',
      notAnswered: 'Você ainda não respondeu',
      remove: 'Remover tomada',
      converting: 'O vídeo está sendo convertido. Aguarde...',
      uploading: 'O vídeo está sendo enviado. Aguarde...',
      error: {
        invalid: 'O arquivo selecionado é muito grande. Por favor, selecione outro arquivo.',
        upload: 'Desculpe, mas não conseguimos fazer o envio do vídeo. Por favor, tente novamente.',
        transcode: 'O arquivo de vídeo selecionado foi corrompido ou não é válido, por favor, tente novamente.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Mostrar mais',
      showLessButtonText: 'Mostrar menos',
      infoText1:
        'Mantenha a aba ativa em primeiro plano durante a gravação. Você não deve usar nenhum outro aplicativo durante a gravação.',
      infoText2:
        'Os vídeos de plano de fundo funcionam melhor nos navegadores mais recentes e com um dispositivo relativamente novo e avançado.',
      infoText3:
        'Certifique-se de que outros aplicativos não estejam usando seu microfone ou câmera.',
    },

    videoResponse: {
      videoPlaceholder: 'Grave a sua resposta',
      uploadPlaceholder: 'Enviar um vídeo',
      submit: 'Enviar resposta',
      notAnswered: 'Você ainda não respondeu',
      startInterview: 'Iniciar entrevista',
    },

    webcam: {
      useVideoBgButtonText: 'Usar plano de fundo do vídeo',
      removeVideoBgButtonText: 'Remover plano de fundo do vídeo',
      starting: 'Começando...',
      close: 'Feche a câmera',
      remove: 'Remover tomada',
      record: 'Gravar',
      stop: 'Parar',
      retake: 'Repetir',
      submit: 'Enviar resposta',
      converting: 'O vídeo está sendo convertido. Aguarde...',
      uploading: 'O vídeo está sendo enviado. Aguarde...',
      downloading: 'O vídeo está sendo baixado. Aguarde...',
      processing: 'Processando...',
      uploadInProgress: 'A transferência de vídeo ainda está em andamento, não feche o navegador nem mude de página.',
      uploaded: 'Vídeo transferido.',
      error: {
        DevicesNotFoundError: 'Não é possível usar a câmera ou microfone. Por favor, verifique se eles estão habilitados.',
        NotFoundError: 'Não é possível usar a câmera ou o microfone. Por favor, verifique se eles estão habilitados.',
        NotAllowedError: 'Você não deu permissão para usar a câmera ou o microfone.',
        PermissionDismissedError: 'Você rejeitou a caixa de diálogo de permissão. Por favor, dê permissão para usar a câmera e microfone.',
        PermissionDeniedError: 'Você negou acesso à câmera ou ao microfone.',
        NotReadableError: 'Não é possível ler o fluxo de câmera ou microfone. Possível problema de hardware.',
        SecurityError: 'Não é possível usar a câmera ou microfone por causa de um erro de segurança',
        stream: 'Ocorreu um erro. Por favor, inicie o seu navegador novamente. Se o problema persistir, por favor tente com um navegador diferente.',
        download: 'O download do vídeo falhou. Tentar de novo?',
        upload: 'O envio do vídeo falhou. Tentar de novo?',
        emptyBlob: 'A memória do seu navegador ou dispositivo está cheia e não consegue criar a gravação. Por favor, atualize a página e se isso não ajudar, reinicie o navegador.  Se o problema persistir, por favor, tente com um navegador diferente.',
        alternativeRecorder: 'Você também pode enviar um arquivo clicando aqui.',
        reconnecting: 'A conexão foi interrompida. Tentando reconectar.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Olá! Queremos convidá-lo para uma entrevista por vídeo ${title}! Este convite também foi enviado para a sua caixa de e-mail. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
